import DashboardPanouPrincipal from "../panou-principal";

export default function DashboardSesizariRedirectionate(props) {
  return <DashboardPanouPrincipal filterStatus="redirected" title="Sesizări redirecționate" {...props} />;
}